import PropTypes from 'prop-types';
import React, {Component} from 'react';

//styles
import {StyledButton, ButtonInner, Right, Left, StyledIcon} from './styles';

class SignInOptionButtonComponent extends Component {
  static propTypes = {
    device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
    iconComponent: PropTypes.func.isRequired,
    iconName: PropTypes.string.isRequired
  };

  render() {
    const {children, device, iconComponent, iconName, ...forwardedProps} = this.props;

    const Icon = StyledIcon.withComponent(iconComponent);

    return (
      <StyledButton block {...forwardedProps} device={device}>
        <ButtonInner>
          <Left device={device}>
            <Icon name={iconName} shouldInheritTextColor={false} device={device} />
          </Left>
          <Right device={device}>{children}</Right>
        </ButtonInner>
      </StyledButton>
    );
  }
}

export const SignInOptionButtonDesktop = props => <SignInOptionButtonComponent device="desktop" {...props} />;
export const SignInOptionButtonMobile = props => <SignInOptionButtonComponent device="mobile" {...props} />;
